import { render, staticRenderFns } from "./ManualGeneralOrderEdit.vue?vue&type=template&id=18ead97e&lang=pug"
import script from "./ManualGeneralOrderEdit.vue?vue&type=script&lang=js"
export * from "./ManualGeneralOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports